module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBggFECs9GeScAAAALklEQVQoz2NgGAyggeE/HtiAX0kDflMa8FvUgN8tDfidi1UaoQSnNEQJXumBAQB2DD/Jcpm8MgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNi0wOFQwNToxNjo0MyswMjowMOPhLesAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDYtMDhUMDU6MTY6NDMrMDI6MDCSvJVXAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/drop-down-arrow.png
// module id = 419
// module chunks = 0